import PlainButton from '../common/PlainButton';
import { useCallback, useState } from 'react';
import ColorPickerUtil from './ColorPickerUtil';
import { hexToColorName } from '../../utils/colorNameUtil';

const ColorPickerDot = ({style = {}, color, onChange, Dyn, colorsArray, size = 24, borderColor = false}) => {
    const [colorHex, setColorHex] = useState(color);
    const styles = {
        cursor: 'pointer',
        background: colorHex,
        width: size,
        height: size,
        border: '2px solid',
        borderColor: borderColor ? borderColor : size <= 12 ? 'transparent' : '#000',
        margin: 0,
        borderRadius: '100%',
        ...style
    }

    const handleClick = useCallback((e) => {
        e.preventDefault();
        const target = e.target;
        const rect = target.getBoundingClientRect();
        const radius = rect.width / 2;
        ColorPickerUtil.show(rect.x + radius, rect.y + radius, radius, colorHex, Dyn, (color) => {
            // Always return focus to the color picker dot when picker closes
            setTimeout(() => {
                target.focus();
            }, 50); // Small delay to ensure picker is fully closed

            if(color?.hex) {
                onChange(color);
                setColorHex(color?.hex);
            }
        }, colorsArray, Dyn.preferences.getTheme());
    }, [colorHex, onChange, Dyn, colorsArray]);

    const getLoc = useCallback((str) => {
        return Dyn.loc( str );
    }, [Dyn]);

    const colorName = hexToColorName(colorHex);

    return (
        <PlainButton className="tde-legend-color tde-mx-2"
        aria-label={`${getLoc('Color picker')}, ${getLoc('current color')}: ${colorName}`}
        style={ styles } onClick={ handleClick }></PlainButton>
    )
};

export default ColorPickerDot;
